<template>
  <section class="contact">
    <div class="fix_width">
      <div class="contact-layout">
        <p>
          感谢您对“HiPay嗨支付”的关注，若有任何问题，您可以填写以下基本资料。
          <br>
          我们会在第一时间将尽快协助处理。
          <span class="tips">或点击立即 <a href="https://vue.livelyhelp.chat/chatWindow.aspx?siteId=5000757&planId=314&chatGroup=3" target="_blank">联系线上客服</a></span>
        </p>
        <table class="contact-table">
          <tr>
            <td><span class="request-mark">*</span> 您的称呼</td>
            <td><input class="input" name="name" v-model="form.name"></td>
          </tr>
          <tr>
            <td><span class="request-mark">*</span> QQ号/微信</td>
            <td><input class="input" name="social_id" v-model="form.social_id"></td>
          </tr>
          <tr>
            <td><span class="request-mark">*</span> 电子邮件</td>
            <td><input class="input" name="email" v-model="form.email"></td>
          </tr>
          <tr class="detail_row">
            <td><span class="request-mark">*</span> 详细情况</td>
            <td><textarea class="textarea" name="name" v-model="form.content"></textarea></td>
          </tr>
          <tr>
            <td colspan="2"><button class="submit-btn" @click="postContact">确认送出</button></td>
          </tr>
        </table>
      </div>
    </div>
  </section>
</template>

<style lang="less" scoped>
@import '../css/common.less';
.contact {
  padding: 50px;
  text-align: left;
  .contact-layout {
    text-align: center;
    margin: 0 auto;
    p{
      display: inline-block;
      text-align: justify;
      line-height: 1.67;
      margin: 20px 0;
    }
  }
  .contact-table {
    margin: 0 auto;
    td{
      text-align: left;
      padding: 20px 0;
      &:first-child{width: 140px;}
      &:last-child{width: 460px;}
    }
    .detail_row{vertical-align: top;}
    tr:last-child td{text-align: right;}
  }
  .tips {
    display: block;
    margin-top: 1em;
    font-weight: 600;
    a {
      color: #d0021b;
    }
  }
  .input, .textarea {
    width: 100%;
    border: 1px solid #b4b4b4;
    outline: none;
    padding: 8px;
    border-radius: 5px;
    box-sizing: border-box;
  }
  .textarea{
    height: 230px;
    resize: none;
  }
  .request-mark {
    color: #ff0000;
  }
  .submit-btn {
    width: 165px;
    height: 45px;
    line-height: 45px;
    background-color: #0038d4;
    color: #fff;
    border: 0;
    cursor: pointer;
    outline: none;
    &::after{
      content: '';
      display: inline-block;
      width: 10px;
      height: 10px;
      border: 1px solid #FFF;
      transform: rotate(45deg);
      border-left: none;
      border-bottom: none;
      margin-left: .5em;
    }

    &:hover{background-color: #007aff;}
  }
}
@media screen and (min-width: 768px) and (max-width: 1050px) {
  .contact {
    padding: 2em;
    text-align: left;
    .contact-layout {
      text-align: left;
      margin: 0 auto;
      padding: 0 5em;
      max-width: 95vw;
      p{
        display: inline-block;
        text-align: justify;
        line-height: 1.67;
        margin: 1.2em 0;
      }
    }
    .contact-table {
      width: 100%;
      margin: 0 auto;
      td{
        text-align: left;
        padding: 1.2em 0;
        &:first-child{width: 7em;}
        &:last-child{width: auto;}
      }
      .detail_row{vertical-align: top;}
      tr:last-child td{text-align: right;}
    }
    .tips {
      display: block;
      margin-top: 1em;
      font-weight: 600;
      a {
        color: #d0021b;
      }
    }
    .input, .textarea {
      width: 100%;
      border: 1px solid #b4b4b4;
      outline: none;
      padding: 8px;
      border-radius: 5px;
      box-sizing: border-box;
    }
    .textarea{
      height: 10em;
      resize: none;
    }
    .request-mark {
      color: #ff0000;
    }
    .submit-btn {
      width: 5.5em;
      height: 2.5em;
      line-height: 2.5em;
      background-color: #0038d4;
      color: #fff;
      border: 0;
      cursor: pointer;
      outline: none;
      &::after{
        content: '';
        display: inline-block;
        width: .8em;
        height: .8em;
        border: 1px solid #FFF;
        transform: rotate(45deg);
        border-left: none;
        border-bottom: none;
        margin-left: .5em;
      }

      &:hover{background-color: #007aff;}
    }
  }
}
@media screen and (max-width: 767.9px) {
  .contact {
    padding: 1.5em;
    .contact-layout {
      p{
        margin: 1em 0;
      }
    }
    .contact-table {
      td{
        padding: 1em 0;
        &:first-child{
          width: 30vw;
          max-width: 6em;
        }
        &:last-child{width: 60vw;}
      }
    }
    .input, .textarea {
      padding: .4em .2em;
      border-radius: .2em;
    }
    .textarea{
      height: 10em;
    }

    .submit-btn {
      width: 8em;
      height: 2.5em;
      line-height: 2.5em;
      &::after{
        width: .6em;
        height: .6em;
        margin-left: .5em;
      }
    }
  }
}
</style>

<script>
import { detectiveUrl } from '../env'
export default {
  name: 'contact',
  data () {
    return {
      form: {
        name: '',
        social_id: '',
        email: '',
        content: ''
      }
    }
  },
  methods: {
    postContact () {
      fetch(`${detectiveUrl()}/api/contact/add`, {
        method: 'POST',
        body: JSON.stringify(this.form)
      }).then((response) => response.json()).then((res) => {
        if (res.code === 200) {
          alert('已送出')
          this.clearForm()
        } else {
          alert(res.message)
        }
      })
    },
    clearForm () {
      for (const key in this.form) {
        this.form[key] = ''
      }
    }
  }
}
</script>
